import getStore from '../store/store';
import QuickAddViewState from '../store/schema/QuickAddViewState';

export default function getQuickAddViewState(): QuickAddViewState {
    return getStore().quickAddViewState;
}
